module.exports = __webpack_public_path__ + "img/ron.6c83c470.jpg";